import React from 'react';
import type { ConsentProfile } from 'types/nhis';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/** 동의 2: 고유식별정보 수집 및 이용 동의 (CONSENT_VERSION 20260423) */
const ConsentDetail2: React.FC<{ profile?: ConsentProfile }> = ({ profile }) => (
  <DetailContainer>
    <DetailTitle $kmrs={profile === 'kmrs'}>고유식별정보 수집 및 이용 동의</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>수집 및 처리 목적</DetailLabel>
          <DetailValue>
            <strong>「개인정보 보호법」에 따라</strong>
            <ul>
              <li>환자 본인의 투약 이력 조회 대행</li>
              <li>본인확인기관 및 간편인증 사업자(통신사, 카카오 등)를 통한 일회성 본인인증</li>
              <li>건강보험심사평가원 연동 절차 수행</li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>처리 항목</DetailLabel>
          <DetailValue><strong>주민등록번호</strong> (또는 외국인등록번호)</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>보유 및 이용 기간</DetailLabel>
          <DetailValue>
            <strong>공공기관 인증 및 투약 이력 연동 완료 즉시 완전 파기</strong>
            <p className="note">
              ※ 당사 서버에 일절 저장되지 않으며, 인증 사업자 전송 후 즉시 휘발됩니다.
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 고유식별정보 처리에 동의를 거부할 수 있습니다.
            <p className="note">
              ※ 단, 공공기관(심사평가원)의 본인인증 법적 요건에 따라 해당 정보 없이는 투약 이력 조회가 원천적으로 불가능하므로, 거부 시 약사의 심층 상담 서비스 이용이 불가합니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail2;
